"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerformQuestionContext = exports.PerformQuestionActionsContext = exports.PerformQuestionController = void 0;
const FormQuestionControllerRegistry_1 = __importDefault(require("@opsbase/lib-form/FormQuestionController/FormQuestionControllerRegistry"));
const isUnlimitedRepetition_1 = __importDefault(require("@opsbase/lib-form/helpers/isUnlimitedRepetition"));
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const react_useimage_1 = require("@opsbase/react-useimage");
const react_1 = __importStar(require("react"));
const usePerform_1 = __importDefault(require("../PerformController/usePerform"));
const usePerformActions_1 = __importDefault(require("../PerformController/usePerformActions"));
function PerformQuestionController(props) {
    var _a;
    const { questionNodeId, children, indent, disabled = false } = props;
    const [ctxChanged, setCtxChanged] = (0, react_1.useState)();
    const { form, selectedNodeId } = (0, usePerform_1.default)();
    const { doUpdateAnswer, doSelectNode, doSelectSiblingNode, doAddRepNode, doDeleteRepNode, hasSiblingNode, } = (0, usePerformActions_1.default)();
    const question = (0, react_1.useRef)(form.questions[questionNodeId]);
    const rule = (0, react_1.useRef)(form.rules[(_a = question.current) === null || _a === void 0 ? void 0 : _a.questionId]);
    const answer = (0, react_1.useRef)(form.answers[questionNodeId]);
    const selected = (0, react_1.useRef)(questionNodeId === selectedNodeId);
    const isUnlimited = (0, react_1.useRef)(false);
    const isAutoSkipped = (0, react_1.useRef)(false);
    const formQuestion = form.questions[questionNodeId];
    const formRule = formQuestion ? form.rules[formQuestion.questionId] : undefined;
    const formAnswer = form.answers[questionNodeId];
    const formUnlimited = (0, isUnlimitedRepetition_1.default)(form, questionNodeId);
    (0, react_1.useEffect)(() => {
        if (disabled)
            return;
        function getUrls() {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                let urlLinks = [];
                const fn = (f) => __awaiter(this, void 0, void 0, function* () {
                    const href = yield (0, react_useimage_1.getImageUrl)(f);
                    urlLinks.push(href);
                });
                const promises = (_b = (_a = formRule === null || formRule === void 0 ? void 0 : formRule.richInfo) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b.map(z => fn(z));
                if (promises === null || promises === void 0 ? void 0 : promises.length)
                    yield Promise.all(promises);
                formRule.richInfo.fileUrls = urlLinks;
                rule.current = formRule;
                setCtxChanged(new Date());
            });
        }
        getUrls().catch(doNothing_1.default);
        question.current = formQuestion;
        rule.current = formRule;
        answer.current = formAnswer;
        isUnlimited.current = formUnlimited;
        setCtxChanged(new Date());
    }, [disabled, formAnswer, formRule, formQuestion, formUnlimited]);
    (0, react_1.useEffect)(() => {
        if (disabled)
            return;
        const isSelected = questionNodeId === selectedNodeId;
        if (isSelected !== selected.current) {
            selected.current = questionNodeId === selectedNodeId;
            setCtxChanged(new Date());
        }
    }, [disabled, questionNodeId, selectedNodeId]);
    const doChangeAnswer = (0, react_1.useMemo)(() => (patch) => {
        const newAnswer = FormQuestionControllerRegistry_1.default[question.current.type].updateAnswer(answer.current, rule.current, patch);
        if (!rule.current.scoring)
            newAnswer.score = null;
        answer.current = newAnswer;
        doUpdateAnswer(questionNodeId, newAnswer);
        setCtxChanged(new Date());
    }, [questionNodeId, doUpdateAnswer]);
    const doSelect = (0, react_1.useMemo)(() => () => {
        doSelectNode(questionNodeId);
    }, [doSelectNode, questionNodeId]);
    const doSkip = (0, react_1.useMemo)(() => (skip, autoSkip) => {
        doChangeAnswer({ notApplicable: skip });
        isAutoSkipped.current = autoSkip;
    }, [doChangeAnswer]);
    const doSelectSibling = (0, react_1.useMemo)(() => (dir, unanswered) => {
        doSelectSiblingNode(questionNodeId, dir, unanswered);
    }, [doSelectSiblingNode, questionNodeId]);
    const hasSibling = (0, react_1.useMemo)(() => (dir, unanswered) => {
        return hasSiblingNode(questionNodeId, dir, unanswered);
    }, [hasSiblingNode, questionNodeId]);
    const doAddRepetition = (0, react_1.useMemo)(() => () => {
        if (!isUnlimited.current)
            return;
        doAddRepNode(question.current.repetitionAncestorId);
    }, [doAddRepNode]);
    const doDeleteRepetition = (0, react_1.useMemo)(() => () => {
        if (!isUnlimited.current)
            return;
        doDeleteRepNode(question.current.repetitionAncestorId);
    }, [doDeleteRepNode]);
    const canAddRepetition = (0, react_1.useMemo)(() => () => {
        if (!isUnlimited.current)
            return false;
        const q = question.current;
        const repNode = form.questions[q.repetitionAncestorId];
        const repTot = repNode.totalRepetitions;
        return q.repetitionIndex === repTot - 1;
    }, [form]);
    const canDeleteRepetition = (0, react_1.useMemo)(() => () => {
        if (!isUnlimited.current)
            return false;
        const repNode = form.questions[question.current.repetitionAncestorId];
        return repNode.totalRepetitions > 1;
    }, [form]);
    const actionsCtx = (0, react_1.useMemo)(() => ({
        doChangeAnswer,
        doSkip,
        doSelect,
        doSelectSibling,
        doAddRepetition,
        doDeleteRepetition,
        hasSibling,
        canAddRepetition,
        canDeleteRepetition,
    }), [
        doAddRepetition,
        doDeleteRepetition,
        doChangeAnswer,
        doSelect,
        doSelectSibling,
        doSkip,
        hasSibling,
        canAddRepetition,
        canDeleteRepetition,
    ]);
    const ctx = (0, react_1.useMemo)(() => ({
        isUnlimited: isUnlimited.current,
        selected: selected.current,
        questionNodeId,
        question: question.current,
        rule: rule.current,
        answer: answer.current,
        indent,
        isAutoSkipped: isAutoSkipped.current,
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ctxChanged]);
    return (react_1.default.createElement(exports.PerformQuestionActionsContext.Provider, { value: actionsCtx },
        react_1.default.createElement(exports.PerformQuestionContext.Provider, { value: ctx }, children)));
}
exports.PerformQuestionController = PerformQuestionController;
exports.default = PerformQuestionController;
exports.PerformQuestionActionsContext = react_1.default.createContext(null);
exports.PerformQuestionContext = react_1.default.createContext(null);
